/**
 * 投放文案 API — GET /api/delivery-copies + POST /api/delivery-copies。
 */
import client from "./client";
import type { DeliveryCopy } from "../types";

/** 文案列表查询参数。 */
export interface CopyListParams {
  product_id?: string;
  status?: string;
  /** 按公司过滤（admin 跨账户筛选用）。 */
  company_id?: string;
  /** 按 id 精确直查（#35：发文记录详情 copy_id 直链）。 */
  copy_id?: string;
}

/**
 * 创建投放文案请求体。
 * 注意：core_selling_points 和 target_media 必须为 string 类型，
 * core_selling_points 须 JSON.stringify() 后传入，禁止传 list/array。
 */
export interface CreateDeliveryCopyRequest {
  product_id: string;
  title: string;
  /** JSON.stringify() 后的字符串，禁止传 array。 */
  core_selling_points: string;
  /** 媒体名称字符串。 */
  target_media: string;
  /** AI 优化建议（可选）。 */
  ai_optimization_advice?: string;
  /** 文章正文 / Markdown 字符串（可选）。 */
  content_body?: string;
  /** 状态：前端创建时显式传 "pending_confirm"。 */
  status: string;
}

/** 获取投放文案列表。 */
export async function getDeliveryCopies(
  params?: CopyListParams,
): Promise<DeliveryCopy[]> {
  return client.get<unknown, DeliveryCopy[]>("/delivery-copies", { params });
}

/**
 * 创建投放文案（从文章资产发起投放）。
 * POST /api/delivery-copies
 *
 * 关键约束：
 * - core_selling_points 必须 JSON.stringify() 后传入，后端为 string 类型
 * - target_media 传媒体名称字符串
 * - status 显式传 "pending_confirm"（后端默认 "draft"）
 */
export async function createDeliveryCopy(
  req: CreateDeliveryCopyRequest,
): Promise<DeliveryCopy> {
  return client.post<unknown, DeliveryCopy>("/delivery-copies", req);
}

/**
 * 确认投放文案（状态机：pending_confirm → confirmed）。
 * PATCH /api/delivery-copies/{id}
 */
export async function confirmDeliveryCopy(
  id: string,
): Promise<{ id: string; status: string }> {
  return client.patch<unknown, { id: string; status: string }>(
    `/delivery-copies/${id}`,
  );
}
